import { EFlatStatsStatus } from '../../types/flatStats';
import { IApplicationState } from '../../types/redux';
import { getDistrictFlatStats } from '../../utils/district/getDistrictFlatStats';

export function selectDistrict(state: IApplicationState) {
  return state.fieldsState.district;
}

export function selectDistrictAveragePrice(state: IApplicationState): number | null {
  const {
    fieldsState: { rooms },
    flatStats,
  } = state;

  if (flatStats.status !== EFlatStatsStatus.Succeed) {
    return null;
  }

  return flatStats.result[rooms].avgPrice;
}

export function selectDistrictAveragePriceLocal(state: IApplicationState): number | null {
  const { district, rooms } = state.fieldsState;
  const flatStats = getDistrictFlatStats(String(district), rooms);

  return flatStats ? flatStats.price : null;
}
